module.exports = __webpack_public_path__ + "img/cloud09.94c73e45.png";